import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import history from '../../../route/history'
import { regisActions, alertActions } from '../../../store/actions'
import moment from 'moment'

const CrtfctManagementMobile = (props) => {
  const [state, setState] = useState({
    isView: false,
    regNo1: '',
    regNo2: '',
    checkedRegNo: false, //주민번호 정상체크
    regNo: '',
    certCode: '',
    rtnCode: '',
    crtfctDetail: [],
    selectedInfo: '',
    editableColor: '',
    selected: false,
  })

  const getCrtfctNumber = () => {
    history.push('/crtfct/mngMobile/CrtfctStepMobile01')
  }

  const sendCrtfctNumber = () => {
    console.log('22', state.selected)
    console.log('33', state.selectedCrtfctInfo)
    if (state.selected) {
      history.push({
        pathname: '/crtfct/mngMobile/CrtfctStepMobile02',
        state: { selectedInfo: state.selectedCrtfctInfo },
      })
    } else {
      props.error({ message: '인증서를 선택해 주세요.' })
    }
  }
  //인증서 목록 가져오기
  useEffect(() => {
    window.M.execute(
      'exWNGetCertList',
      window.M.response
        .on(function (status, result) {
          //console.log(status);
          //console.log(JSON.stringify(result));
          //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result.data.certList));
          if (status === 'SUCCESS') {
            setState({ ...state, crtfctDetail: result.data.certList })
            //console.log(state.crtfctDetail);
            //console.log(state.crtfctDetail.subjectDn);
          }
        })
        .toString(),
    )
  }, [])

  const handleClick = (info, index) => {
    setState({
      ...state,
      selected: true,
      selectedCrtfctInfo: info,
      crtfctDetail: state.crtfctDetail.map((detail, idx) =>
        idx === index ? { ...detail, editableColor: '#B0ECFF' } : { ...detail, editableColor: '' },
      ),
    })
  }
  return (
    <React.Fragment>
      {/* <!-- contents --> */}
      <div id="contents">
        <div className="content-header">
          <a
            href="#"
            className="page-prev"
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
          >
            뒤로이동
          </a>
          {/* <!-- mobile --> */}
          <h2>공동인증서 관리</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>마이페이지</span>
            <em>공동인증서 관리</em>
          </div>
        </div>

        <div className="certify-wrap">
          <ul className="certify-list">
            {state.crtfctDetail.length > 0 ? (
              state.crtfctDetail.map((info, index) => (
                <li onClick={() => handleClick(info, index)} style={{ backgroundColor: info.editableColor }}>
                  <a href="#">
                    <div className="box">
                      <div className="img"></div>
                      <div className="info">
                        <dl key={index}>
                          <dt>
                            {info.subjectDn.split('=')[1].split('(')[0]}
                            <input type="hidden" id="subjectDn" name="subjectDn" value={info.subjectDn} />
                          </dt>
                          <dd>{info.issuerDn.split('=')[3].split(',')[0]}</dd>
                          <dd>만료일 : {moment(info.notAfter).format('YYYY.MM.DD')}</dd>
                        </dl>
                      </div>
                    </div>
                  </a>
                  {/* <button type="button" className="btn-del">삭제</button> */}
                </li>
              ))
            ) : (
              <>
                <div className="non-certify">저장된 인증서가 없습니다.</div>
              </>
            )}
          </ul>

          <a className="btn-confirm" onClick={getCrtfctNumber}>
            가져오기
          </a>
          <a className="btn-confirm mt8" onClick={sendCrtfctNumber}>
            내보내기
          </a>
        </div>
      </div>
      {/* <!-- //contents --> */}
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    checkedRegNo: state.regis.checkedRegNo,
  }
}

const actionCreators = {
  success: alertActions.success,
  error: alertActions.error,
  checkedRegNo: regisActions.checkedRegNo,
  onCrtfctfInfo: regisActions.onCrtfctfInfo,
  delCrtfctfInfo: regisActions.delCrtfctfInfo,
}

export default connect(mapStateToProps, actionCreators)(CrtfctManagementMobile)
